import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="show-more"
export default class extends Controller {
  static targets = ["more", "toggler"]

  connect() {
  }

  toggle() {
    this.moreTargets.forEach(target => {
      target.classList.toggle("d-none", false)
    })
    this.togglerTarget.classList.toggle("d-none", true)
  }
}
